const getUserLocale = () => {
  const languages = window.navigator.languages;
  let isFa: boolean = false;

  languages.forEach((lang: string) => {
    if (lang === "fa-IR" || lang === "fa") {
      isFa = true;
    }
  });
  // return isFa ? "fa-IR" : languages[0];
  return "fa-IR";
};

export default getUserLocale;
